/**
 * Сервис для работы с ролями и админ-пользователями
 */

import api from './api'
import { compressImage, shouldCompress } from '@/utils/imageCompression'

const API_PREFIX = '/admin'

export const adminRolesService = {
	// ========== Роли ==========

	/**
	 * Получить все роли
	 */
	async getRoles() {
		const response = await api.get(`${API_PREFIX}/roles`)
		return response.data // interceptor уже возвращает response.data
	},

	/**
	 * Получить роль по ID
	 */
	async getRoleById(id) {
		const response = await api.get(`${API_PREFIX}/roles/${id}`)
		return response.data
	},

	/**
	 * Создать роль
	 */
	async createRole(data) {
		const response = await api.post(`${API_PREFIX}/roles`, data)
		return response.data
	},

	/**
	 * Обновить роль
	 */
	async updateRole(id, data) {
		const response = await api.put(`${API_PREFIX}/roles/${id}`, data)
		return response.data
	},

	/**
	 * Удалить роль
	 */
	async deleteRole(id) {
		const response = await api.delete(`${API_PREFIX}/roles/${id}`)
		return response
	},

	/**
	 * Получить все права
	 */
	async getPermissions() {
		const response = await api.get(`${API_PREFIX}/roles/permissions/all`)
		return response.data
	},

	// ========== Админ-пользователи ==========

	/**
	 * Логин админа
	 */
	async login(email, password) {
		const response = await api.post(`${API_PREFIX}/admin-users/login`, { email, password })
		return response.data
	},

	/**
	 * Получить текущего админа
	 */
	async getCurrentUser() {
		const response = await api.get(`${API_PREFIX}/admin-users/me`)
		return response.data
	},

	/**
	 * Обновить аватар текущего админа
	 */
	async uploadMyAvatar(file) {
		// Сжимаем изображение если оно больше 500KB
		let fileToUpload = file
		if (shouldCompress(file, 0.5)) {
			console.log(`🗜️ Сжатие аватара админа: ${(file.size / 1024 / 1024).toFixed(2)}MB`)
			fileToUpload = await compressImage(file, {
				maxWidth: 800,
				maxHeight: 800,
				quality: 0.85,
				maxSizeMB: 0.5,
			})
			console.log(`✅ Сжато до: ${(fileToUpload.size / 1024 / 1024).toFixed(2)}MB`)
		}

		const formData = new FormData()
		formData.append('avatar', fileToUpload)
		const response = await api.post(`${API_PREFIX}/admin-users/me/avatar`, formData)
		return response.data
	},

	/**
	 * Получить права текущего админа
	 */
	async getMyPermissions() {
		const response = await api.get(`${API_PREFIX}/admin-users/me/permissions`)
		return response.data
	},

	/**
	 * Получить всех админ-пользователей
	 */
	async getAdminUsers(params = {}) {
		const response = await api.get(`${API_PREFIX}/admin-users`, { params })
		return response.data
	},

	/**
	 * Получить админ-пользователя по ID
	 */
	async getAdminUserById(id) {
		const response = await api.get(`${API_PREFIX}/admin-users/${id}`)
		return response.data
	},

	/**
	 * Создать админ-пользователя
	 */
	async createAdminUser(data) {
		const response = await api.post(`${API_PREFIX}/admin-users`, data)
		return response.data
	},

	/**
	 * Обновить админ-пользователя
	 */
	async updateAdminUser(id, data) {
		const response = await api.put(`${API_PREFIX}/admin-users/${id}`, data)
		return response.data
	},

	/**
	 * Удалить админ-пользователя
	 */
	async deleteAdminUser(id) {
		const response = await api.delete(`${API_PREFIX}/admin-users/${id}`)
		return response
	},
}

export default adminRolesService
